import { useAddressDeliverableStore } from "@/scenes/OrderManagement/store/AddressDeliverableStore";
import { AddressDeliverable } from "@/services/api/addressDeliverableCheck";
import { CheckOutlined, CloseOutlined, ExclamationOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import "./index.less";

interface DeliverableIconProps {
    orderId: number;
}

const DeliverableIcon: React.FC<DeliverableIconProps> = (props) => {
    const { orderId } = props;

    const { orderDeliverableMap } = useAddressDeliverableStore();

    const deliverableStatus = orderDeliverableMap.get(orderId);

    if (deliverableStatus === AddressDeliverable.DELIVERABLE) {
        return (
            <Tooltip title="可以派送">
                <div className="deliverable-icon">
                    <div style={{ width: 20, height: 20, display: "inline-block" }}>
                        <svg viewBox="0 0 1024 1024" className="deliverable">
                            <path
                                stroke="#3c763d"
                                d="M913.017 237.02c-25.311-25.312-66.349-25.312-91.66 0l-412.475 412.474-206.237-206.237c-25.312-25.312-66.35-25.312-91.661 0s-25.312 66.35 0 91.66l252.067 252.067c0.729 0.73 1.439 1.402 2.134 2.029 25.434 23.257 64.913 22.585 89.527-2.029l458.303-458.303c25.313-25.312 25.313-66.35 0.001-91.661z"
                            />
                        </svg>
                    </div>
                </div>
            </Tooltip>
        );
    }

    if (deliverableStatus === AddressDeliverable.UNKNOWN) {
        return (
            <Tooltip title="不确定是否可达，请联系快递公司确认">
                <div className="deliverable-icon">
                    <div style={{ width: 20, height: 20, display: "inline-block" }}>
                        <svg viewBox="0 0 1024 1024" className="unknown">
                            <path
                                stroke="#f5222d"
                                d="M 526 150C 576 150 602 175 601 224C 600 300 600 350 575 525C 570 560 560 575 525 575C 525 575 475 575 475 575C 440 575 430 560 425 525C 400 355 400 300 400 226C 400 175 425 150 475 150M 500 650C 527 650 552 661 571 679C 589 698 600 723 600 750C 600 805 555 850 500 850C 445 850 400 805 400 750C 400 723 411 698 429 679C 448 661 473 650 500 650C 500 650 500 650 500 650"
                            />
                        </svg>
                    </div>
                </div>
            </Tooltip>
        );
    }

    if (deliverableStatus === AddressDeliverable.UN_DELIVERABLE) {
        return (
            <Tooltip title="可能无法派送，请到快递官网核实是否可派送">
                <div className="deliverable-icon">
                    <div style={{ width: 16, height: 16, display: "inline-block" }}>
                        <svg viewBox="0 0 1024 1024" className="undeliverable">
                            <path
                                stroke="#f5222d"
                                d="M602.512147 511.99738l402.747939-402.747939a63.999673 63.999673 0 0 0-90.509537-90.509537L512.00261 421.487843 109.254671 18.749904a63.999673 63.999673 0 0 0-90.509537 90.509537L421.493073 511.99738 18.755134 914.745319a63.999673 63.999673 0 0 0 90.509537 90.509537L512.00261 602.506917l402.747939 402.747939a63.999673 63.999673 0 0 0 90.509537-90.509537z"
                            />
                        </svg>
                    </div>
                </div>
            </Tooltip>
        );
    }

    return null;
};

export default observer(DeliverableIcon);
